<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="getMappedDeposit"
    :mobile-breakpoint="0"
    :hide-default-header="$vuetify.breakpoint.xsOnly"
    hide-default-footer
    :items-per-page="$vuetify.breakpoint.xsOnly ? 8 : 8"
    @page-count="pageCount = $event"
    :page.sync="page"
    :search="search"
  >
    <template v-slot:item.value="{ item }">
      <span>{{ item.value }}</span>
      <span class="caption ml-1">$</span>
    </template>
    <template v-slot:top>
      <v-row align="center" justify="end">
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TillHistoryGrid",
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getDeposits", "getTills"]),
    getMappedDeposit() {
      return this.getDeposits.map(d => {
        const till = this.getTills.find(t => t.id === d.id_till);
        return {
          ...d,
          date: till ? till.end_date : "",
          signataire: till ? till.signataire : ""
        };
      });
    }
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      search: "",
      headers: [
        { text: "Date", value: "date" },
        { text: "Fait par", value: "signataire" },
        { text: "Montant", value: "value", align: "end" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
